<div class="cartItems">
    <adm-data-grid [data]="data" [isClientSide]="true" [dataGridState]="dataGridState" [selectable]="false">
        <adm-data-grid-column
                [filterable]="false"
                field="itemNumber"
                [title]="'ADMIN_ANALYTICS_ITEMNUMBER' | translate"></adm-data-grid-column>
        <adm-data-grid-column
                [filterable]="false"
                field="typeDescription"
                [title]="'ADMIN_ANALYTICS_TYPE_DESCRIPTION' | translate"></adm-data-grid-column>
        <adm-data-grid-column [filterable]="false" field="quantity" [title]="'ADMIN_ANALYTICS_QUANTITY' | translate">
            <ng-template admDataGridCell let-dataItem>{{ dataItem.quantity }} {{ dataItem.unitOfQuantity }}
            </ng-template>
        </adm-data-grid-column>
        <adm-data-grid-column [filterable]="false" field="retailQuantity"
                              [title]="'ADMIN_ANALYTICS_RETAIL_QUANTITY' | translate">
            <ng-template admDataGridCell let-dataItem>{{ dataItem.retailQuantity }} {{ dataItem.unitOfQuantity }}
            </ng-template>
        </adm-data-grid-column>
        <adm-data-grid-column [filterable]="false" field="price" [title]="'ADMIN_PRICE' | translate">
            <ng-template admDataGridCell let-dataItem>{{ dataItem.price | number : '1.2-2' }} {{ dataItem.unitOfPrice }}
            </ng-template>
        </adm-data-grid-column>
        <adm-data-grid-column [filterable]="false" field="totalPrice"
                              [title]="'ADMIN_ANALYTICS_TOTAL_PRICE' | translate">
            <ng-template admDataGridCell
                         let-dataItem>{{ dataItem.totalPrice | number : '1.2-2' }} {{ dataItem.unitOfPrice }}
            </ng-template>
        </adm-data-grid-column>
    </adm-data-grid>
</div>
